import '@/components/header/header.css';
import '@/components/footer/footer.css';
import '@/css/common/common.css';
import '../components/suspend/suspend.css';

import '../components/suspend/suspend.js';
import './jquery/jquery.waypoints.min.js';
import './jquery/jquery.countup.js';
import '../css/common/css/style.css'
import '../css/common/css/xui.css';
import '../css/common/message.min.css'
import '../components/header/header.js';
import '../components/footer/footer.js';
import './common/message.min.js';
import '../api/api.js'
import { LOGINURLBASE } from '../api/api.js'


(function () {

  var commonFunction = {
      switchToke: function(that,Element,targetElement, activeElement, switchElement){
        $(`.${targetElement} div`).removeClass(activeElement);
        $('.triangle').remove();
        that.addClass(activeElement);
        $(`.${activeElement}`).parent()[0].appendChild(Element);
        refreshClue(that,switchElement);
      }
  }

  //拓客线索的切换的内容函数
  function refreshClue(Elem, switchElement) {//Elem传递的是点击的div
    if(Elem[0].id == 'clue1'){
        $(`.${switchElement} > div`).css('display','none');
        $(`.${switchElement} > div:nth-child(1)`).css('display','block');
    }else if(Elem[0].id == 'clue2'){
        $(`.${switchElement} > div`).css('display','none');
        $(`.${switchElement} > div:nth-child(2)`).css('display','block');
    }else if(Elem[0].id == 'clue3'){
        $(`.${switchElement} > div`).css('display','none');
        $(`.${switchElement} > div:nth-child(3)`).css('display','block');
    }else if(Elem[0].id == 'clue4'){
        $(`.${switchElement} > div`).css('display','none');
        $(`.${switchElement} > div:nth-child(4)`).css('display','block');
    }
  }
  
  $(".jump-link").click(function(){
    window.open(`${LOGINURLBASE}`,"_blank");
  })

  var autoAnimation = {
    visiable: false, 
    exitVisable: false, //确认不在浏览器显示屏中
    getTimeOut: function ( time, element ,sumElement){
      const timeSpeed = 10; //默认的每100ms变化一次
      const changeSum = time / 10; //一个轮回变化的次数
      var numberArr = []; // 暂存所有dom的现在的值和最大值的数组

      // 遍历dom，拿值
      element.forEach((item) => {
        numberArr.push({
          now: 0,
          max: item.attr("sum")
        })
      })

      // 延迟动画
      if($(sumElement).attr("sum-arry") === "join"){
          element.forEach((item, index)=>{
            setTime(item);
          })
      }

      function setTime(item) {
        $('#' + item.attr("id")).countUp();
      }
    
    //   function setTime(element2, index) {
    //     // 当前dom最大值
    //     var subMax = numberArr[index].max;
    //     // 当前dom增加速度
    //     var speed = numberArr[index].max / changeSum;

    //     setTimeout(()=>{
    //       // 设置现在的值
    //       numberArr[index].now += speed;
    //       // 当现在的值小于最大值，就赋值dom的值并继续动画
    //       if(numberArr[index].now < subMax){
    //         element2.text(Math.floor(numberArr[index].now));
    //         setTime(element2, index);
    //       // 当现在的值大于等于最大值，就
    //       } else{
    //         // 赋值dom的值为最大值
    //         element2.text(subMax);
    //         // 赋值当前最小值为最大值
    //         numberArr[index].now = subMax;
    //         // 检测是否所有都到了最大值
    //         var isAllMax = true
    //         numberArr.forEach((item) => {
    //           if(item.now !== item.max){
    //             isAllMax = false;
                
    //           }
    //         })
    //         // 如果都到所有都到了最大值就重新开始
    //         if (isAllMax) {
    //           // autoAnimation.visiable = false;
    //           // console.log('>>kkkkk',autoAnimation);
    //           // autoAnimation.getTimeOut(countTime, time, element);
    //         }
    //       }
    //     }, timeSpeed); 
    //   }
    }
  }
  window.animateTimeOut = autoAnimation;

  var onScrollElement = {
    sumArray: [],
    // clientHeight: null,//页面的可视高度
    elementArry: [], //存放所有有sum-arry属性，处理后的元素
    dataHandle: function(){
      var sumArray = $('*[sum-arry]');
      onScrollElement.sumArray = sumArray;
      sumArray.map((item)=>{
        var sumElement = sumArray[item] //每项元素
        var sumElementPosition = sumElement.offsetTop; //每项元素的位置
        var sumHeight = sumElement.offsetHeight; //每项元素的高度
        var elementObj = {
          sumElement,
          sumElementPosition,
          sumHeight
        }
        onScrollElement.elementArry.push(elementObj);
      })
    },
    onScrollAuto: function(elementItem,clientHeight){
      var scrollTop = $(document).scrollTop();  //当前页面的滚动高度
      var sumElement = elementItem.sumElement;
      var sumElementPosition = elementItem.sumElementPosition;
      var sumHeight = elementItem.sumHeight;
     
  
      if(sumElementPosition - clientHeight < scrollTop && sumElementPosition + sumHeight > scrollTop){
        var sumAttribute = $(sumElement).attr("sum-arry");
        if( sumAttribute === "exit"){
          $(sumElement).attr("sum-arry","join");
          var sumItemArray = $(sumElement).find($("[sum]"));
          var TimeOutArry = [];
          sumItemArray.map((i)=>{
            TimeOutArry.push($(sumItemArray[i]))
          })
          animateTimeOut.getTimeOut(2000,TimeOutArry ,sumElement);
        }
      }else{
        $(sumElement).attr("sum-arry","exit");
      }
    }
  }

  // 页面懒加载
  var lazyLoad = function(clientHeight) {
    // 获取所有的含有data-src属性的元素
    var imgArray = $('*[data-src]');
    
    
    var scrollTop = $(document).scrollTop();  //当前页面的滚动高度
    imgArray.map((i)=>{
        var img = imgArray[i];
        var nowImgHeight = null;
        if($(img)[0].offsetParent !== 'body'){
          nowImgHeight = $(img)[0].offsetTop
        }else {
          nowImgHeight = $(img).parent().offsetTop
        }

        // 如果图片的offestTop在区间内则把data-src的地址赋给src
        if(nowImgHeight - clientHeight - 200 < scrollTop && 
          nowImgHeight + clientHeight + 200 > scrollTop){
            $(img).context.src = $(img).context.dataset.src;
        }else if(nowImgHeight === 0){
          $(img).context.src = $(img).context.dataset.src;
        }
    })
}
  
  window.commonjs = commonFunction;
  window.lazyLoad = lazyLoad;
  window.onScrollElement = onScrollElement;
}(window)); 



// WEBPACK FOOTER //
// ./src/js/common.js